import { Component } from 'react';
import PropTypes from 'prop-types';

/* eslint-disable */

const mutateDataByGroups = (data = [], key) => {
  const groups = {};
  const mutateDataArr = [];

  for (const item of data) {
    if (groups[item[key]]) {
      groups[item[key]].push(item);
    } else {
      groups[item[key]] = [item];
    }
  }

  for (const objKey in groups) {
    if (groups.hasOwnProperty(objKey)) {
      mutateDataArr.push({
        label: objKey,
        data: groups[objKey]
      });
    }
  }

  return mutateDataArr;
};

class Select extends Component {
  state = {
    isOpen: false
  }

  componentWillUnmount() {
    document.removeEventListener(this.outsideEventType, this.handleOutsideClick, false);
  }

  outsideEventType = 'ontouchstart' in document.documentElement ? 'touchstart' : 'mousedown';

  handleClick = () => {
    if (!this.state.isOpen) {
      document.addEventListener(this.outsideEventType, this.handleOutsideClick, false);
    } else {
      document.removeEventListener(this.outsideEventType, this.handleOutsideClick, false);
    }

    this.setState((prevState) => ({ isOpen: !prevState.isOpen }), this.props.onOpen);
  }

  handleOutsideClick = (e) => {
    if (this.node && this.node.contains(e.target)) { return; }
    this.setState({ isOpen: false });
  }

  handleChange = (item) => {
    const { multiselect, onChange } = this.props;

    multiselect || this.setState({ isOpen: false });

    onChange(item, multiselect);
  }

  getValue = () => {
    const { labelKey, checked, placeholder } = this.props;
    let value = <span className="placeholder">{placeholder}</span>;

    if (checked) {
      const checkedValues = Object.values(checked);

      if (checkedValues.length) {
        value = checkedValues.map((el) => el[labelKey]).join(', ');
      }
    }

    return value;
  }

  render() {
    const { data, markedKey, labelKey, groupByKey, checked, className, theme } = this.props;
    const { isOpen } = this.state;
    let list;
    

    if (isOpen && data.length) {
      if (groupByKey) {
        const groupData = mutateDataByGroups(data, groupByKey);

        list = (
          <ul className="select-list">
            {groupData.map((group, groupIndex) => (
              <li key={groupIndex}>
                <div className="select-title">{group.label}</div>
                <ul>
                  {group.data.map((item, index) => (
                    <li
                      key={index}
                      className={'select-item ' + (checked[item[markedKey]] ? 'active' : '')}
                      onClick={() => this.handleChange(item)}>
                      {item[labelKey]}
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        );
      } else {
        list = (
          <ul className="select-list">
            {data.map((item, index) => (
              <li
                key={index}
                className={'select-item ' + (checked[item[markedKey]] ? 'active' : '')}
                onClick={() => this.handleChange(item)}>
                {item[labelKey]}
              </li>
            ))}
          </ul>
        );
      }
    }

    return (
      <div
        className={`react-select ${theme} ${className} ${isOpen ? 'open' : ''}`}
        ref={(node) => (this.node = node)}>
        <span
          className="field"
          onClick={this.handleClick}>
          {this.getValue()}
        </span>

        {list}
      </div>
    );
  }
}

Select.propTypes = {
  data: PropTypes.array,
  markedKey: PropTypes.string,
  labelKey: PropTypes.string,
  groupByKey: PropTypes.string,
  checked: PropTypes.object,
  placeholder: PropTypes.string,
  multiselect: PropTypes.bool,
  className: PropTypes.string,
  theme: PropTypes.string,
  onChange: PropTypes.func,
  onOpen: PropTypes.func,
};

Select.defaultProps = {
  data: [],
  markedKey: 'id',
  labelKey: 'label',
  checked: null,
  placeholder: '\u00A0',
  multiselect: false,
  className: '',
  theme: '',
  onChange: () => { },
  onOpen: () => { }
};

export default Select;
